import React, { useState } from "react";

import { deleteField } from "firebase/firestore";

import {
    createProduct,
    deleteProduct,
    updateProduct
} from "../../services/firebase/firestore";


const AdminObraForm = ({
    obra = null,
    onClose,
    onSaved,
    onDeleted
}) => {

    const isNew = !obra;

    const isEnabled = (value) => {
        return value === true || value === "si";
    };


    const [productId, setProductId] = useState(
        obra?.id || ""
    );


    const [form, setForm] = useState({
        nombre: obra?.nombre || "",
        descripcion: obra?.descripcion || "",
        precio: obra?.precio ?? "",
        moneda: obra?.moneda || "USD",

        categoria: obra?.categoria || "",
        seccion: obra?.seccion || "",
        ordenHome: obra?.ordenHome || "",

        largo: obra?.largo ?? "",
        alto: obra?.alto ?? "",
        ancho: obra?.ancho ?? "",
        diametro: obra?.diametro ?? "",

        activo: obra
            ? isEnabled(obra.activo)
            : true,

        home: obra
            ? isEnabled(obra.home)
            : false
    });


    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);


    const handleChange = (e) => {

        const {
            name,
            value,
            type,
            checked
        } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === "checkbox"
                ? checked
                : value
        }));

    };


    const cleanId = (value) => {

        return value
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-_]/g, "");

    };


    const getCreateData = () => {

        const data = {
            nombre: form.nombre,
            moneda: form.moneda,
            categoria: form.categoria,
            seccion: form.seccion,
            activo: form.activo,
            home: form.home
        };


        if (form.descripcion !== "") {
            data.descripcion = form.descripcion;
        }

        if (form.precio !== "") {
            data.precio = Number(form.precio);
        }

        if (form.ordenHome !== "") {
            data.ordenHome = form.ordenHome;
        }

        if (form.largo !== "") {
            data.largo = form.largo;
        }

        if (form.alto !== "") {
            data.alto = form.alto;
        }

        if (form.ancho !== "") {
            data.ancho = form.ancho;
        }

        if (form.diametro !== "") {
            data.diametro = form.diametro;
        }


        return data;

    };


    const getUpdateData = () => {

        return {
            nombre: form.nombre,

            descripcion: form.descripcion === ""
                ? deleteField()
                : form.descripcion,

            precio: form.precio === ""
                ? deleteField()
                : Number(form.precio),

            moneda: form.moneda,

            categoria: form.categoria,
            seccion: form.seccion,

            ordenHome: form.ordenHome === ""
                ? deleteField()
                : form.ordenHome,

            largo: form.largo === ""
                ? deleteField()
                : form.largo,

            alto: form.alto === ""
                ? deleteField()
                : form.alto,

            ancho: form.ancho === ""
                ? deleteField()
                : form.ancho,

            diametro: form.diametro === ""
                ? deleteField()
                : form.diametro,

            activo: form.activo,
            home: form.home
        };

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        setSaving(true);
        setError("");
        setSuccess(false);


        try {

            if (isNew) {

                const id = cleanId(productId);

                if (!id) {
                    setError("Tenés que ingresar un ID para la obra.");
                    return;
                }


                const createData = getCreateData();


                await createProduct(
                    id,
                    createData
                );


                const nuevaObra = {
                    id,
                    ...createData
                };


                if (onSaved) {
                    onSaved(nuevaObra);
                }


            } else {

                await updateProduct(
                    obra.id,
                    getUpdateData()
                );


                const obraActualizada = {
                    ...obra,
                    ...form,

                    precio: form.precio === ""
                        ? undefined
                        : Number(form.precio)
                };


                if (onSaved) {
                    onSaved(obraActualizada);
                }

            }


            setSuccess(true);


        } catch (error) {

            console.error(error);

            if (error.message === "product-exists") {

                setError(
                    "Ya existe una obra con ese ID."
                );

            } else {

                setError(
                    isNew
                        ? "No se pudo crear la obra."
                        : "No se pudieron guardar los cambios."
                );

            }

        } finally {

            setSaving(false);

        }

    };


    const handleDelete = async () => {

        if (!obra) {
            return;
        }


        const confirmed = window.confirm(
            `¿Seguro que querés eliminar "${obra.nombre || obra.id}"?\n\nEsta acción no se puede deshacer.`
        );


        if (!confirmed) {
            return;
        }


        setDeleting(true);
        setError("");


        try {

            await deleteProduct(obra.id);

            if (onDeleted) {
                onDeleted(obra.id);
            }

        } catch (error) {

            console.error(error);

            setError(
                "No se pudo eliminar la obra."
            );

        } finally {

            setDeleting(false);

        }

    };


    return (
        <div className="admin-edit">

            <div className="admin-section-title">

                <h2>
                    {isNew
                        ? "Agregar obra"
                        : `Editar ${obra.nombre}`
                    }
                </h2>

                <button
                    type="button"
                    onClick={onClose}
                >
                    Volver
                </button>

            </div>


            <form
                className="admin-form"
                onSubmit={handleSubmit}
            >

                <div className="admin-form-group">

                    <label>
                        ID / nombre del archivo
                    </label>

                    <input
                        type="text"
                        value={productId}
                        onChange={(e) =>
                            setProductId(e.target.value)
                        }
                        disabled={!isNew}
                        required
                    />

                    <small>
                        La imagen debe llamarse{" "}
                        <strong>
                            {cleanId(productId) || "id-de-la-obra"}.webp
                        </strong>
                    </small>

                </div>


                <div className="admin-form-group">

                    <label>
                        Nombre
                    </label>

                    <input
                        type="text"
                        name="nombre"
                        value={form.nombre}
                        onChange={handleChange}
                        required
                    />

                </div>


                <div className="admin-form-group">

                    <label>
                        Descripción
                    </label>

                    <textarea
                        name="descripcion"
                        value={form.descripcion}
                        onChange={handleChange}
                        rows="5"
                    />

                </div>


                <div className="admin-form-row">

                    <div className="admin-form-group">

                        <label>
                            Precio
                        </label>

                        <input
                            type="number"
                            name="precio"
                            value={form.precio}
                            onChange={handleChange}
                        />

                    </div>


                    <div className="admin-form-group">

                        <label>
                            Moneda
                        </label>

                        <select
                            name="moneda"
                            value={form.moneda}
                            onChange={handleChange}
                        >
                            <option value="USD">
                                USD
                            </option>

                            <option value="ARS">
                                Pesos
                            </option>
                        </select>

                    </div>

                </div>


                <div className="admin-form-row">

                    <div className="admin-form-group">

                        <label>
                            Categoría
                        </label>

                        <select
                            name="categoria"
                            value={form.categoria}
                            onChange={handleChange}
                            required
                        >
                            <option value="">
                                Seleccionar categoría
                            </option>

                            <option value="especiales">
                                Especiales
                            </option>

                            <option value="en-serie">
                                En serie
                            </option>

                            <option value="unicas">
                                Únicas
                            </option>
                        </select>

                    </div>


                    <div className="admin-form-group">

                        <label>
                            Sección
                        </label>

                        <select
                            name="seccion"
                            value={form.seccion}
                            onChange={handleChange}
                            required
                        >
                            <option value="">
                                Seleccionar sección
                            </option>

                            <option value="obras">
                                Obras
                            </option>

                            <option value="primitiva">
                                Primitiva
                            </option>
                        </select>

                    </div>

                </div>


                <div className="admin-form-row">

                    <div className="admin-form-group">

                        <label>
                            Largo
                        </label>

                        <input
                            type="text"
                            name="largo"
                            value={form.largo}
                            onChange={handleChange}
                        />

                    </div>


                    <div className="admin-form-group">

                        <label>
                            Alto
                        </label>

                        <input
                            type="text"
                            name="alto"
                            value={form.alto}
                            onChange={handleChange}
                        />

                    </div>


                    <div className="admin-form-group">

                        <label>
                            Ancho
                        </label>

                        <input
                            type="text"
                            name="ancho"
                            value={form.ancho}
                            onChange={handleChange}
                        />

                    </div>


                    <div className="admin-form-group">

                        <label>
                            Diámetro
                        </label>

                        <input
                            type="text"
                            name="diametro"
                            value={form.diametro}
                            onChange={handleChange}
                        />

                    </div>

                </div>


                <div className="admin-form-group">

                    <label>
                        Orden en Home
                    </label>

                    <input
                        type="number"
                        name="ordenHome"
                        value={form.ordenHome}
                        onChange={handleChange}
                    />

                </div>


                <div className="admin-form-checks">

                    <label>

                        <input
                            type="checkbox"
                            name="activo"
                            checked={form.activo}
                            onChange={handleChange}
                        />

                        Obra activa

                    </label>


                    <label>

                        <input
                            type="checkbox"
                            name="home"
                            checked={form.home}
                            onChange={handleChange}
                        />

                        Mostrar en Home

                    </label>

                </div>


                {error &&
                    <p className="admin-error">
                        {error}
                    </p>
                }


                {success &&
                    <p className="admin-success">
                        {isNew
                            ? "Obra creada correctamente."
                            : "Cambios guardados correctamente."
                        }
                    </p>
                }


                <div className="admin-form-actions">

                    <button
                        type="submit"
                        disabled={saving || deleting}
                    >
                        {saving
                            ? "Guardando..."
                            : isNew
                                ? "Crear obra"
                                : "Guardar cambios"
                        }
                    </button>


                    {!isNew &&
                        <button
                            type="button"
                            className="admin-delete"
                            onClick={handleDelete}
                            disabled={saving || deleting}
                        >
                            {deleting
                                ? "Eliminando..."
                                : "Eliminar obra"
                            }
                        </button>
                    }

                </div>

            </form>

        </div>
    );

};


export default AdminObraForm;